<template>
  <div
    class="d-flex flex-row border rounded h-100 attachment-background"
  >
    <div
      class="p-2"
    >
      <BImg
        v-if="file.file_extension === 'pdf'"
        :src="pdfImageEndpoint"
        class="attachment"
      />
      <BImg
        v-else
        :src="uploadedDocumentEndpoint"
        :blank-src="getInvalidImageUrl"
        :alt="file.file_original_name"
        class="attachment"
        @error="({ target }) => target.src = getInvalidImageUrl"
      />
    </div>
    <div class="d-flex flex-column justify-content-between w-100 h-100 p-2">
      <div class="d-flex flex-column">
        <div class="text-break font-weight-bolder">
          {{ file.file_original_name }}
        </div>
        <div style="font-size: 12px;">
          {{ Number(file.file_size / 1000).toFixed(2) }} KB
        </div>
      </div>
      <div class="d-flex gap-2 align-self-end">
        <BButton
          size="sm"
          variant="warning"
          @click.prevent="$emit('file:preview', file)"
        >
          View
        </BButton>
        <BButton
          variant="outline-dark"
          size="sm"
          :disabled="progress > 0"
          @click.prevent="downloadFile"
        >
          Download
        </BButton>
      </div>

      <div
        v-if="progress > 0"
      >
        Downloading . . .
        <BProgress
          :value="progress"
          striped
          animated
          show-progress
          variant="primary"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { SSharedMemos } from '@/services/shared'

export default {
  name: 'AttachmentDownloader',

  props: {
    path: {
      type: String,
      required: true
    },
    file: {
      type: Object,
      required: true,
      default: () => ({
        file_original_name: '',
        file_hashed_name: '',
        file_extension: '',
        file_size: 0
      })
    }
  },

  emits: [
    'file:preview'
  ],

  data () {
    return {
      progress: 0
    }
  },

  computed: {
    uploadedDocumentEndpoint () {
      return `${process.env.VUE_APP_API_BASE_URL}/${this.path}/${this.file.file_hashed_name}`
    },

    getInvalidImageUrl () {
      return `${window.location.origin}/img/invalid-image.png`
    },

    pdfImageEndpoint () {
      return `${window.location.origin}/img/pdf.png`
    }
  },

  methods: {

    downloadFile () {
      const payload = {
        attachment_path: this.path,
        file_name: this.file.file_hashed_name
      }

      SSharedMemos.retrieveFile(payload, progress => {
        this.progress = progress
      }).then(
        ({ data }) => {
          const blob = new Blob([data])
          const url = window.URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.href = url
          a.download = this.file.file_original_name
          document.body.appendChild(a)
          a.click()

          a.remove()
          window.URL.revokeObjectURL(url)
        }
      ).finally(() => {
        this.progress = 0
      })
    }
  }
}
</script>
